import React, { useEffect, useState, useRef } from 'react';
import '../../../styles/components/sections/Instructions.css';

const steps = [
  {
    id: 1,
    title: "Nova era nege vozila",
    text: "Instaliraj ClickWash i postani deo moderne mreže za pranje automobila. Registracija je brza, jednostavna i gotova za manje od minuta.",
    image: "/images/steps/step1.jpg" 
  },
  {
    id: 2,
    title: "Izaberi svoj plan",
    text: "Odaberi pretplatu koja ti najviše odgovara. U svakom trenutku imaš jasan uvid u preostale žetone i trajanje tvog paketa direktno u aplikaciji.",
    image: "/images/steps/step2.jpg" 
  },
  {
    id: 3,
    title: "Pronađi perionicu",
    text: "Tvoja lokalna perionica je sada svuda. Na interaktivnoj mapi lako pronađi najbližu partnersku lokaciju u Beogradu i šire.",
    image: "/images/steps/step3.jpg" 
  },
  {
    id: 4,
    title: "Skeniraj i operi",
    text: "Zaboravi na keš i kovanice. Jednim dodirom skeniraj QR kod na aparatu, izaberi broj žetona i tvoj auto je spreman za blistav sjaj.",
    image: "/images/steps/step4.jpg" 
  }
];

const Instructions = () => {
  const [activeStep, setActiveStep] = useState(0);
  const stepRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveStep(parseInt(entry.target.dataset.index));
          }
        });
      },
      { 
        rootMargin: "-30% 0px -30% 0px", // Preciznije okidanje u centru
        threshold: 0.5 
      }
    );

    stepRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section id="instructions" className="instructions-section">
      <div className="container">
        <h2 className="instructions-main-header">Sve je lakše uz ClickWash</h2>
        
        <div className="instructions-grid">
          
          {/* DESKTOP STICKY SLIKA */}
          <div className="instructions-visual-desktop">
            <div className="phone-sticky-view">
              {steps.map((step, index) => (
                <img
                  key={step.id}
                  src={step.image}
                  alt={step.title}
                  className={`phone-mockup-desktop ${activeStep === index ? 'active' : ''}`}
                />
              ))}
            </div>
          </div>

          {/* TEKST I MOBILNE SLIKE */}
          <div className="instructions-content-flow">
            {steps.map((step, index) => (
              <div 
                key={step.id} 
                className={`step-wrapper ${activeStep === index ? 'active' : ''}`}
                ref={el => stepRefs.current[index] = el}
                data-index={index}
              >
                <div className="step-text-box">
                  {/* UKRASNI KORAK BROJ */}
                  <div className="step-label-container">
                    <span className="step-label">KORAK {step.id}</span>
                    <div className="step-label-bg"></div>
                  </div>
                  
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>

                {/* MOBILNA SLIKA */}
                <div className="step-image-mobile">
                  <img src={step.image} alt={step.title} />
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default Instructions;